import { render, staticRenderFns } from "./DialogGeneralConsentDetail.vue?vue&type=template&id=58b0f0bf&"
import script from "./DialogGeneralConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DialogGeneralConsentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports